webpackJsonp([13],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return all; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_companies__ = __webpack_require__(93);



var all = function all(_ref, params) {
  var commit = _ref.commit;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_companies__["a" /* getCompanies */](params).then(function (_ref2) {
    var data = _ref2.data;

    commit('receive', data);
    commit('loading', false, { root: true });
  });
};

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return all; });

var all = function all(state) {
  return state.all;
};

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(101);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    all: []
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: {
    receive: function receive(state, companies) {
      state.all = companies;
    }
  }
});

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attachAttachment", function() { return attachAttachment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_mailing__ = __webpack_require__(94);



var all = function all(_ref) {
  var commit = _ref.commit;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_mailing__["a" /* getMailings */]().then(function (_ref2) {
    var data = _ref2.data;

    commit('receive', data);
    commit('loading', false, { root: true });
  });
};

var get = function get(_ref3, id) {
  var commit = _ref3.commit;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_mailing__["b" /* getMailing */](id).then(function (_ref4) {
    var data = _ref4.data;

    commit('current', data);
    commit('loading', false, { root: true });
  }).catch(function (error) {
    commit('errorMessage', error.response.data.message, { root: true });
    commit('loading', false, { root: true });
    throw error;
  });
};

var create = function create(_ref5, _ref6) {
  var commit = _ref5.commit,
      dispatch = _ref5.dispatch;
  var tenderId = _ref6.tenderId,
      stageId = _ref6.stageId,
      name = _ref6.name;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_mailing__["c" /* create */]({ tenderId: tenderId, stageId: stageId, name: name }).then(function () {
    commit('loading', false, { root: true });
    dispatch('all');
  }).catch(function (error) {
    commit('errorMessage', error.response.data.message, { root: true });
    commit('loading', false, { root: true });
    throw error;
  });
};

var update = function update(_ref7, _ref8) {
  var state = _ref7.state,
      commit = _ref7.commit,
      dispatch = _ref7.dispatch;
  var text = _ref8.text,
      date = _ref8.date,
      recipients = _ref8.recipients;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_mailing__["d" /* update */](state.current._id, { text: text, date: date, recipients: recipients }).then(function () {
    commit('loading', false, { root: true });
    dispatch('get', state.current._id);
  }).catch(function (error) {
    commit('errorMessage', error.response.data.message, { root: true });
    commit('loading', false, { root: true });
    throw error;
  });
};

var attachAttachment = function attachAttachment(_ref9, attachment) {
  var dispatch = _ref9.dispatch,
      commit = _ref9.commit,
      state = _ref9.state;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_mailing__["e" /* attachment */](state.current._id, attachment).then(function () {
    commit('successMessage', 'Условия загружены', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "current", function() { return current; });

var all = function all(state) {
  return state.mailings;
};

var current = function current(state) {
  return state.current;
};

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    mailings: [],
    current: {
      _id: null,
      text: null,
      recipients: [],
      date: new Date(),
      attachment: {
        name: null
      }
    }
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: {
    receive: function receive(state, mailings) {
      state.mailings = mailings;
    },
    current: function current(state, mailing) {
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.assignIn(state.current, mailing);
    }
  }
});

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "answer", function() { return answer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "agree", function() { return agree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveBids", function() { return saveBids; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_participation__ = __webpack_require__(31);



var all = function all(_ref) {
  var commit = _ref.commit;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_participation__["d" /* getParticipations */]().then(function (_ref2) {
    var data = _ref2.data;

    commit('receive', data);
    commit('loading', false, { root: true });
  });
};

var get = function get(_ref3, id) {
  var commit = _ref3.commit;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_participation__["e" /* getParticipation */](id).then(function (_ref4) {
    var data = _ref4.data;

    commit('current', data);
    commit('loading', false, { root: true });
  }).catch(function (error) {
    commit('errorMessage', error.response.data.message, { root: true });
    commit('loading', false, { root: true });
    throw error;
  });
};

var answer = function answer(_ref5, questionnaire) {
  var commit = _ref5.commit,
      state = _ref5.state,
      dispatch = _ref5.dispatch;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_participation__["f" /* answer */](state.current._id, questionnaire).then(function () {
    commit('successMessage', 'Анкета сохранена', { root: true });
    return dispatch('get', state.current._id);
  }).catch(function (error) {
    commit('errorMessage', error.response.data.message, { root: true });
    commit('loading', false, { root: true });
  });
};

var agree = function agree(_ref6, id) {
  var commit = _ref6.commit,
      state = _ref6.state,
      dispatch = _ref6.dispatch;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_participation__["g" /* agree */](id).then(function () {
    return dispatch('all');
  }).catch(function () {
    commit('errorMessage', 'Ошибка согласия', { root: true });
    commit('loading', false, { root: true });
  });
};

var saveBids = function saveBids(_ref7, bids) {
  var commit = _ref7.commit,
      state = _ref7.state,
      dispatch = _ref7.dispatch;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_participation__["h" /* bids */](state.current._id, bids).then(function () {
    commit('successMessage', 'Ставки загружены', { root: true });
    return dispatch('get', state.current._id);
  }).catch(function () {
    commit('errorMessage', 'Ошибка загрузки ставок', { root: true });
    commit('loading', false, { root: true });
  });
};

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "current", function() { return current; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);



var all = function all(state) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(state.participations, 'tender.id');
};

var current = function current(state) {
  return state.current;
};

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    participations: [],
    current: {
      tender: {},
      participant: {},
      stage: {
        type: 'questionnaire',
        questionnaire: {
          groups: []
        }
      }
    }
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: {
    receive: function receive(state, participations) {
      state.participations = participations;
    },
    current: function current(state, participation) {
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.assignIn(state.current, participation);
    }
  }
});

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "describe", function() { return describe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "archive", function() { return archive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attachConditions", function() { return attachConditions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addStage", function() { return addStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameStage", function() { return renameStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeStage", function() { return removeStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "launchStage", function() { return launchStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suspendStage", function() { return suspendStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inviteToStage", function() { return inviteToStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLotsToStage", function() { return loadLotsToStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stageQuestionnaire", function() { return stageQuestionnaire; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTenderStageParticipations", function() { return getTenderStageParticipations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "planStageDates", function() { return planStageDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "report", function() { return report; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableParticipation", function() { return disableParticipation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableParticipation", function() { return enableParticipation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_tender__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_participation__ = __webpack_require__(31);




var all = function all(_ref) {
  var commit = _ref.commit;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["h" /* getTenders */]().then(function (_ref2) {
    var data = _ref2.data;

    commit('receive', data);
    commit('loading', false, { root: true });
  });
};

var get = function get(_ref3, id) {
  var commit = _ref3.commit;

  commit('loading', null, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["i" /* getTender */](id).then(function (_ref4) {
    var data = _ref4.data;

    data.createdAt = new Date(data.createdAt);
    data.stages.map(function (s) {
      if (s.scheduledLaunch) {
        s.scheduledLaunch = new Date(s.scheduledLaunch);
      }
      if (s.scheduledSuspend) {
        s.scheduledSuspend = new Date(s.scheduledSuspend);
      }
      return s;
    });
    commit('current', data);
    commit('loading', false, { root: true });
  }).catch(function () {
    commit('errorMessage', 'Ошибка загрузки тендера', { root: true });
    commit('loading', false, { root: true });
  });
};

var create = function create(_ref5, _ref6) {
  var dispatch = _ref5.dispatch,
      commit = _ref5.commit;
  var name = _ref6.name,
      description = _ref6.description,
      holderName = _ref6.holderName;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["j" /* createTender */]({ name: name, description: description, holderName: holderName }).then(function () {
    return dispatch('all');
  }).then(function () {
    commit('successMessage', 'Тендер создан', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

var describe = function describe(_ref7, _ref8) {
  var dispatch = _ref7.dispatch,
      commit = _ref7.commit,
      state = _ref7.state;
  var name = _ref8.name,
      description = _ref8.description,
      holderName = _ref8.holderName;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["k" /* describe */](state.current._id, { name: name, description: description, holderName: holderName }).then(function () {
    return dispatch('get', state.current._id);
  }).then(function () {
    commit('successMessage', 'Тендер обновлен', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

var archive = function archive(_ref9, id) {
  var dispatch = _ref9.dispatch,
      commit = _ref9.commit;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["l" /* archive */](id).then(function () {
    return dispatch('all');
  }).then(function () {
    commit('successMessage', 'Тендер отправлен в архив', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

var attachConditions = function attachConditions(_ref10, condtitions) {
  var dispatch = _ref10.dispatch,
      commit = _ref10.commit,
      state = _ref10.state;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["m" /* conditions */](state.current._id, condtitions).then(function () {
    return dispatch('all');
  }).then(function () {
    commit('successMessage', 'Условия загружены', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

var addStage = function addStage(_ref11, stage) {
  var dispatch = _ref11.dispatch,
      commit = _ref11.commit,
      state = _ref11.state;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["n" /* addStage */](state.current._id, stage).then(function () {
    return dispatch('get', state.current._id);
  }).then(function () {
    commit('successMessage', 'Этап добавлен', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

var renameStage = function renameStage(_ref12, _ref13) {
  var dispatch = _ref12.dispatch,
      commit = _ref12.commit,
      state = _ref12.state;
  var stageId = _ref13.id,
      name = _ref13.name;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["o" /* renameStage */](state.current._id, stageId, name).then(function () {
    return dispatch('get', state.current._id);
  }).then(function () {
    commit('successMessage', 'Этап переименован', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

var removeStage = function removeStage(_ref14, stageId) {
  var dispatch = _ref14.dispatch,
      commit = _ref14.commit,
      state = _ref14.state;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["p" /* removeStage */](state.current._id, stageId).then(function () {
    return dispatch('get', state.current._id);
  }).then(function () {
    commit('successMessage', 'Этап удален', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

var launchStage = function launchStage(_ref15, stageId) {
  var dispatch = _ref15.dispatch,
      commit = _ref15.commit,
      state = _ref15.state;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["q" /* launchStage */](state.current._id, stageId).then(function () {
    return dispatch('get', state.current._id);
  }).then(function () {
    commit('successMessage', 'Этап запущен', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

var suspendStage = function suspendStage(_ref16, stageId) {
  var dispatch = _ref16.dispatch,
      commit = _ref16.commit,
      state = _ref16.state;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["r" /* suspendStage */](state.current._id, stageId).then(function () {
    return dispatch('get', state.current._id);
  }).then(function () {
    commit('successMessage', 'Этап остановлен', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

var inviteToStage = function inviteToStage(_ref17, _ref18) {
  var dispatch = _ref17.dispatch,
      commit = _ref17.commit,
      state = _ref17.state;
  var stageId = _ref18.stageId,
      invites = _ref18.invites;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["s" /* inviteToStage */](state.current._id, stageId, invites).then(function () {
    return dispatch('getTenderStageParticipations', stageId);
  }).then(function () {
    commit('successMessage', 'Участники приглашены', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

var loadLotsToStage = function loadLotsToStage(_ref19, _ref20) {
  var dispatch = _ref19.dispatch,
      commit = _ref19.commit,
      state = _ref19.state;
  var stageId = _ref20.stageId,
      lots = _ref20.lots,
      keys = _ref20.keys;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["t" /* loadLotsToStage */](state.current._id, stageId, { lots: lots, keys: keys }).then(function () {
    return dispatch('get', state.current._id);
  }).then(function () {
    commit('successMessage', 'Лоты загружены', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

var stageQuestionnaire = function stageQuestionnaire(_ref21, _ref22) {
  var dispatch = _ref21.dispatch,
      commit = _ref21.commit,
      state = _ref21.state;
  var stageId = _ref22.stageId,
      questionnaire = _ref22.questionnaire;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["u" /* stageQuestionnaire */](state.current._id, stageId, questionnaire).then(function () {
    return dispatch('get', state.current._id);
  }).then(function () {
    commit('successMessage', 'Анкета сохранена', { root: true });
    commit('loading', false, { root: true });
    return true;
  });
};

var getTenderStageParticipations = function getTenderStageParticipations(_ref23, stageId) {
  var commit = _ref23.commit,
      state = _ref23.state,
      rootState = _ref23.rootState;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["v" /* getTenderStageParticipations */](rootState.route.params.id || state.current._id, stageId || rootState.route.params.stageId).then(function (_ref24) {
    var data = _ref24.data;

    commit('stageParticipations', data);
    return true;
  }).then(function () {
    commit('loading', false, { root: true });
    return true;
  });
};

var planStageDates = function planStageDates(_ref25, _ref26) {
  var commit = _ref25.commit,
      state = _ref25.state,
      dispatch = _ref25.dispatch;
  var stageId = _ref26.stageId,
      scheduledLaunch = _ref26.scheduledLaunch,
      scheduledSuspend = _ref26.scheduledSuspend;

  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["w" /* planStageDates */](state.current._id, stageId, { scheduledLaunch: scheduledLaunch, scheduledSuspend: scheduledSuspend }).then(function () {
    return dispatch('get', state.current._id);
  }).then(function () {
    commit('successMessage', 'Даты запланированы', { root: true });
  });
};

var report = function report(_ref27, stageId) {
  var commit = _ref27.commit,
      state = _ref27.state,
      dispatch = _ref27.dispatch;

  return __WEBPACK_IMPORTED_MODULE_0__api_tender__["x" /* report */](state.current._id, stageId).then(function () {
    commit('successMessage', 'Расчет произведен', { root: true });
  });
};

var disableParticipation = function disableParticipation(_ref28, participationId) {
  var commit = _ref28.commit,
      dispatch = _ref28.dispatch,
      state = _ref28.state;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_1__api_participation__["i" /* disable */](participationId).then(function () {
    return dispatch('getTenderStageParticipations');
  }).catch(function () {
    commit('errorMessage', 'Ошибка выключения', { root: true });
    commit('loading', false, { root: true });
  });
};

var enableParticipation = function enableParticipation(_ref29, participationId) {
  var commit = _ref29.commit,
      dispatch = _ref29.dispatch,
      state = _ref29.state;

  commit('loading', true, { root: true });
  return __WEBPACK_IMPORTED_MODULE_1__api_participation__["j" /* enable */](participationId).then(function () {
    return dispatch('getTenderStageParticipations');
  }).catch(function () {
    commit('errorMessage', 'Ошибка включения', { root: true });
    commit('loading', false, { root: true });
  });
};

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "current", function() { return current; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stage", function() { return stage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stageParticipations", function() { return stageParticipations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stageParticipationsAsCompanies", function() { return stageParticipationsAsCompanies; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);



var all = function all(state) {
  return state.tenders;
};

var current = function current(state) {
  return state.current;
};

var stage = function stage(state, getters, rootState) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state.current.stages, { id: rootState.route.params.stageId }) || __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.first(state.current.stages);
};

var stageParticipations = function stageParticipations(state) {
  return state.stageParticipations;
};

var stageParticipationsAsCompanies = function stageParticipationsAsCompanies(state) {
  return state.stageParticipations.map(function (p) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.assign(p.participant, { enabled: p.enabled, participationId: p._id });
  });
};

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    tenders: [],
    stageParticipations: [],
    current: {
      _id: 0,
      name: null,
      description: null,
      conditions: {
        name: null,
        path: null
      },
      holder: {
        name: null
      },
      stages: [{
        id: 1,
        enabled: false,
        scheduledLaunch: new Date(),
        scheduledSuspend: new Date()
      }],
      questionnaire: {}
    }
  },
  mutations: {
    receive: function receive(state, tenders) {
      state.tenders = tenders;
    },
    current: function current(state, tender) {
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.assignIn(state.current, tender);
    },
    stageParticipations: function stageParticipations(state, participations) {
      state.stageParticipations = participations;
    }
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__
});

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_axios__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      mini: false,
      test: true,
      items: [{
        icon: 'gavel',
        title: 'Мои тендеры',
        route: {
          name: 'Tenders'
        },
        show: ['shipper']
      }, {
        icon: 'pan_tool',
        title: 'Участие',
        route: {
          name: 'Participations'
        },
        show: ['shipper', 'carrier']
      }, {
        icon: 'list',
        title: 'База вопросов',
        route: {
          name: 'QuestionsBase'
        },
        show: ['shipper']
      }, {
        icon: 'email',
        title: 'Рассылки',
        route: {
          name: 'Mailings'
        },
        show: ['shipper']
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Tender'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    'loading': 'loading',
    'user': 'auth/user',
    'success': 'success',
    'error': 'error',
    'authenticated': 'auth/authenticated'
  })),
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_3__auth__["a" /* checkAuth */]()) {
      this.storeLogin({
        company: __WEBPACK_IMPORTED_MODULE_3__auth__["b" /* tokenPayload */]('company'),
        name: __WEBPACK_IMPORTED_MODULE_3__auth__["b" /* tokenPayload */]('name')
      });
    }
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_4__api_axios__["a" /* default */].interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      if (error) {
        vm.stopLoading(false);
      }
      if (error.response && error.response.status === 401) {
        vm.logout();
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['clearSuccessMessage', 'clearErrorMessage', 'successMessage', 'errorMessage', 'stopLoading']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])({
    'storeLogin': 'auth/login',
    'storeLogout': 'auth/logout'
  }), {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_3__auth__["c" /* removeToken */]();
      this.storeLogout();
      this.$router.push({
        name: 'auth'
      });
    },
    err: function err() {
      throw new Error('testing error');
    }
  })
});

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return storeToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tokenPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return authHeader; });
var storeToken = function storeToken(token) {
  window.localStorage.setItem('jwt', token);
};

var getToken = function getToken() {
  return window.localStorage.getItem('jwt');
};

var removeToken = function removeToken() {
  window.localStorage.removeItem('jwt');
};

var tokenPayload = function tokenPayload(key) {
  var token = getToken();
  if (!token) {
    return null;
  }
  var splitToken = token.split('.');
  if (!splitToken[1]) {
    return null;
  }
  return key ? JSON.parse(atob(splitToken[1]))[key] : JSON.parse(atob(splitToken[1]));
};

var checkAuth = function checkAuth() {
  var payload = tokenPayload();
  if (!payload || !payload.exp || Date.now() > payload.exp * 1000) {
    removeToken();
    return false;
  }
  return true;
};

var authHeader = function authHeader() {
  return getToken() ? 'Bearer ' + getToken() : '';
};

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.c5c5068.png";

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-btn', {
    staticStyle: {
      "display": "none"
    },
    nativeOn: {
      "click": function($event) {
        _vm.err($event)
      }
    }
  }, [_vm._v("\n    error\n  ")]), _vm._v(" "), (!_vm.authenticated) ? [_c('main', [_c('v-container', [_c('router-view', {
    attrs: {
      "name": "auth"
    }
  })], 1)], 1)] : [_c('v-navigation-drawer', {
    attrs: {
      "clipped": "",
      "permanent": "",
      "dark": "",
      "mini-variant": _vm.mini
    }
  }, [_c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return (item.show.indexOf(_vm.user.company.type) > -1) ? _c('router-link', {
      key: item.title,
      staticClass: "list__tile",
      attrs: {
        "title": item.title,
        "tag": "a",
        "to": item.route
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticStyle: {
        "color": "white"
      }
    }, [_vm._v("\n              " + _vm._s(item.icon) + "\n            ")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])], 1)], 1) : _vm._e()
  }))], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "tender__color",
    attrs: {
      "fixed": ""
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "100%"
    },
    attrs: {
      "src": __webpack_require__(151),
      "alt": ""
    }
  }), _vm._v(" "), _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v("\n      " + _vm._s(_vm.user.name) + " (" + _vm._s(_vm.user.company.name) + ")\n      "), _c('v-btn', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("выйти")])], 1), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view', [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "slot": "loading"
    },
    slot: "loading"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "slot": "loading",
      "xs1": ""
    },
    slot: "loading"
  }, [_c('v-progress-circular', {
    staticClass: "cyan--text lighten-3",
    attrs: {
      "indeterminate": "",
      "size": 100,
      "width": 7
    }
  })], 1), _vm._v(" "), _c('v-spacer')], 1) : _vm._e()], 1)], 1)], 1)], _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.success.enabled),
      callback: function($$v) {
        _vm.$set(_vm.success, "enabled", $$v)
      },
      expression: "success.enabled"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-alert', {
    attrs: {
      "success": "",
      "value": "true"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.success.message) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.error.enabled),
      callback: function($$v) {
        _vm.$set(_vm.error, "enabled", $$v)
      },
      expression: "error.enabled"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-alert', {
    attrs: {
      "error": "",
      "value": "true"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.error.message) + "\n        ")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getParticipations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getParticipationsAgro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getParticipation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getParticipationAgro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeBidAgro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return answer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return agree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return disable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return enable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return bids; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(6);


var getParticipations = function getParticipations() {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/participation');
};

var getParticipationsAgro = function getParticipationsAgro() {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/participation/agro');
};

var getParticipation = function getParticipation(id) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/participation/' + id);
};

var getParticipationAgro = function getParticipationAgro(id) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/participation/agro/' + id);
};

var makeBidAgro = function makeBidAgro(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/participation/agro/' + id + '/bid', data);
};
var answer = function answer(id, questionnaire) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/participation/' + id + '/answer', questionnaire);
};

var agree = function agree(id) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/participation/' + id + '/agree');
};

var disable = function disable(id) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/participation/' + id + '/disable');
};

var enable = function enable(id) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/participation/' + id + '/enable');
};

var bids = function bids(id, _bids) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/participation/' + id + '/bids', _bids);
};

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(153);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/auth',
    name: 'auth',
    components: {
      'auth': function auth() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 158));
      }
    }
  }, {
    path: '/tenders',
    name: 'Tenders',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 166));
    }
  }, {
    path: '/mailings',
    name: 'Mailings',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 160));
    }
  }, {
    path: '/mailings/:id',
    name: 'Mailing',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 159));
    }
  }, {
    path: '/tenders/:id',
    name: 'Tender',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 164));
    },
    children: [{
      name: 'stage',
      path: 'stage/:stageId/',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 165));
      }
    }]
  }, {
    path: '/tenders/agro/:id',
    name: 'TenderAgro',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 168));
    }
  }, {
    path: '/participation',
    name: 'Participations',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 162));
    }
  }, {
    path: '/participation/agro/:id',
    name: 'ParticipationsAgro',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 167));
    }
  }, {
    path: '/participation/:id',
    name: 'Participation',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 161));
    }
  }, {
    path: '/base',
    name: 'QuestionsBase',
    components: {
      default: function _default() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 163));
      },
      test: function test() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 157));
      }
    }
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_tender__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_participation__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_mailing__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_companies__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_questionsBase__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  state: {
    loading: false,
    success: {
      message: null,
      enabled: false
    },
    error: {
      message: null,
      enabled: false
    },
    questionsBase: {
      groups: [{
        name: 'Общие вопросы',
        weight: 3,
        questions: [{
          text: 'Как дела?',
          weight: 2,
          type: 'one_option',
          options: [{
            value: 'Норм',
            weight: 3
          }, {
            value: 'Пойдет',
            weight: 4
          }, {
            value: 'Супер',
            weight: 5
          }]
        }]
      }]
    }
  },
  mutations: {
    startLoading: function startLoading(state) {
      state.loading = true;
    },
    stopLoading: function stopLoading(state) {
      state.loading = false;
    },
    loading: function loading(state, loadingState) {
      state.loading = loadingState;
    },
    clearSuccessMessage: function clearSuccessMessage(state) {
      state.success.message = null;
      state.success.enabled = false;
    },
    successMessage: function successMessage(state, payload) {
      state.success.message = payload;
      state.success.enabled = true;
    },
    clearErrorMessage: function clearErrorMessage(state) {
      state.error.message = null;
      state.error.enabled = null;
    },
    errorMessage: function errorMessage(state, payload) {
      state.error.message = payload;
      state.error.enabled = true;
    },
    patchGroup: function patchGroup(state, _ref) {
      var index = _ref.index,
          _ref$group = _ref.group,
          name = _ref$group.name,
          weight = _ref$group.weight;

      state.questionsBase.groups[index].name = name;
      state.questionsBase.groups[index].weight = weight;
    },
    patchQuestion: function patchQuestion(state, _ref2) {
      var question = _ref2.question,
          group = _ref2.group,
          currentGroupIndex = _ref2.currentGroupIndex,
          currentQuestionIndex = _ref2.currentQuestionIndex;

      if (state.questionsBase.groups[currentGroupIndex].questions[currentQuestionIndex]) {
        if (group === currentGroupIndex) {
          __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.assignIn(state.questionsBase.groups[currentGroupIndex].questions[currentQuestionIndex], question);
        } else {
          state.questionsBase.groups[currentGroupIndex].questions.splice(currentQuestionIndex, 1);
          state.questionsBase.groups[group].questions.push(question);
        }
      }
    },
    postQuestion: function postQuestion(state, _ref3) {
      var question = _ref3.question,
          group = _ref3.group;

      if (state.questionsBase.groups[group]) {
        state.questionsBase.groups[group].questions.push(question);
      }
    },
    addGroup: function addGroup(state) {
      state.questionsBase.groups.push({
        name: 'Новая группа',
        weight: 1,
        questions: []
      });
    },
    deleteQuestion: function deleteQuestion(state, _ref4) {
      var g = _ref4.groupNumber,
          q = _ref4.questionNumber;

      state.questionsBase.groups[g].questions.splice(q, 1);
    },
    deleteGroup: function deleteGroup(state, index) {
      state.questionsBase.groups.splice(index, 1);
    },
    deleteGroupSaving: function deleteGroupSaving(state, index) {
      if (state.questionsBase.groups[index]) {
        state.questionsBase.groups[index].questions.forEach(function (q) {
          state.questionsBase.groups[0].questions.push(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(q));
        });
      }
      state.questionsBase.groups.splice(index, 1);
    },
    copyGroup: function copyGroup(state, index) {
      if (state.questionsBase.groups[index]) {
        state.questionsBase.groups.push(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(state.questionsBase.groups[index]));
      }
    },
    copyQuestion: function copyQuestion(state, _ref5) {
      var g = _ref5.groupNumber,
          q = _ref5.questionNumber;

      if (state.questionsBase.groups[g] && state.questionsBase.groups[g].questions[q]) {
        state.questionsBase.groups[g].questions.push(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(state.questionsBase.groups[g].questions[q]));
      }
    },
    loadBase: function loadBase(state, _ref6) {
      var groups = _ref6.groups;

      if (groups) {
        state.questionsBase.groups = groups;
      }
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    success: function success(state) {
      return state.success;
    },
    error: function error(state) {
      return state.error;
    },
    questionsBase: function questionsBase(state) {
      return state.questionsBase;
    }
  },
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */],
    tender: __WEBPACK_IMPORTED_MODULE_3__modules_tender__["a" /* default */],
    participation: __WEBPACK_IMPORTED_MODULE_4__modules_participation__["a" /* default */],
    mailing: __WEBPACK_IMPORTED_MODULE_5__modules_mailing__["a" /* default */],
    companies: __WEBPACK_IMPORTED_MODULE_6__modules_companies__["a" /* default */]
  },
  actions: {
    postBase: function postBase(_ref7) {
      var state = _ref7.state,
          commit = _ref7.commit;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_questionsBase__["a" /* postBase */])({
        groups: state.questionsBase.groups
      }).then(function () {
        commit('successMessage', 'База сохранена', { root: true });
      }).catch(function (err) {
        commit('errorMessage', err.message, { root: true });
      });
    },
    getBase: function getBase(_ref8) {
      var commit = _ref8.commit;

      commit('startLoading');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_questionsBase__["b" /* getBase */])().then(function (_ref9) {
        var groups = _ref9.data.groups;

        commit('loadBase', { groups: groups }, { root: true });
        commit('stopLoading');
      }).catch(function (err) {
        if (!(err.response.status === 404)) {
          commit('errorMessage', err.message, { root: true });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(142)

var Component = __webpack_require__(62)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(152),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(13);



var instance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: "https://dev-tenderapi.logist-pro.su"
});

instance.interceptors.request.use(function (config) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__auth__["d" /* authHeader */])()) {
    config.headers.common['Authorization'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__auth__["d" /* authHeader */])();
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getTender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTenders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLastTenders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getTenderStageParticipations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return createTender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return describe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return archive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return addStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return renameStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return removeStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return conditions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return launchStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return suspendStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return inviteToStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return loadLotsToStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return stageQuestionnaire; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return planStageDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return report; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return prepare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tenderParticipations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tenderDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sendInvites; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sendWinnerEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(6);



var getTender = function getTender(id) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/tender/' + id);
};

var getTenders = function getTenders() {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/tender');
};

var getLastTenders = function getLastTenders() {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/tender/last');
};

var getTenderStageParticipations = function getTenderStageParticipations(tenderId, stageId) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/tender/' + tenderId + '/stage/' + stageId + '/participations');
};

var createTender = function createTender(_ref) {
  var name = _ref.name,
      description = _ref.description,
      holderName = _ref.holderName;

  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender', { name: name, description: description, holderName: holderName });
};

var describe = function describe(id, _ref2) {
  var name = _ref2.name,
      description = _ref2.description,
      holderName = _ref2.holderName;

  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + id + '/describe', { name: name, description: description, holderName: holderName });
};

var archive = function archive(id) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + id + '/archive');
};

var addStage = function addStage(tenderId, stage) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + tenderId + '/stage', stage);
};

var renameStage = function renameStage(tenderId, stageId, name) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + tenderId + '/stage/' + stageId + '/rename', { name: name });
};

var removeStage = function removeStage(tenderId, stageId) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].delete('/tender/' + tenderId + '/stage/' + stageId);
};

var conditions = function conditions(tenderId, _conditions) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + tenderId + '/conditions', _conditions);
};

var launchStage = function launchStage(tenderId, stageId) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + tenderId + '/stage/' + stageId + '/launch');
};

var suspendStage = function suspendStage(tenderId, stageId) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + tenderId + '/stage/' + stageId + '/suspend');
};

var inviteToStage = function inviteToStage(tenderId, stageId, invites) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + tenderId + '/stage/' + stageId + '/invite', {
    participants: invites
  });
};

var loadLotsToStage = function loadLotsToStage(tenderId, stageId, _ref3) {
  var lots = _ref3.lots,
      keys = _ref3.keys;

  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + tenderId + '/stage/' + stageId + '/lots', { lots: lots, keys: keys });
};

var stageQuestionnaire = function stageQuestionnaire(tenderId, stageId, questionnaire) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + tenderId + '/stage/' + stageId + '/questionnaire', questionnaire);
};

var planStageDates = function planStageDates(tenderId, stageId, _ref4) {
  var scheduledLaunch = _ref4.scheduledLaunch,
      scheduledSuspend = _ref4.scheduledSuspend;

  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + tenderId + '/stage/' + stageId + '/dates', { scheduledLaunch: scheduledLaunch, scheduledSuspend: scheduledSuspend });
};

var report = function report(tenderId, stageId) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + tenderId + '/stage/' + stageId + '/report');
};

var getLists = function getLists() {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/lists');
};

var prepare = function prepare(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + id + '/prepare', data);
};

var tenderParticipations = function tenderParticipations(id) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/tender/' + id + '/participations');
};

var tenderDates = function tenderDates(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + id + '/dates', data);
};

var sendInvites = function sendInvites(id) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/' + id + '/invites');
};

var sendWinnerEmail = function sendWinnerEmail(participationId) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/tender/winner/' + participationId);
};

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return login; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(6);


var login = function login(email, password) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post("https://lp.s2b-group.net/auth/jwt", { email: email, password: password });
};

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCompanies; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(6);


var getCompanies = function getCompanies(_ref) {
  var name = _ref.name,
      from = _ref.from,
      limit = _ref.limit;

  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get("https://lp.s2b-group.net/api/companies", {
    params: { name: name, from: from, limit: limit }
  });
};

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMailings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMailing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return attachment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(6);


var getMailings = function getMailings() {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/mailing');
};

var getMailing = function getMailing(id) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/mailing/' + id);
};

var create = function create(data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/mailing', data);
};

var update = function update(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].patch('/mailing/' + id, data);
};

var attachment = function attachment(tenderId, _attachment) {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/mailing/' + tenderId + '/attachment', _attachment);
};

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return postBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(6);


var postBase = function postBase(_ref) {
  var groups = _ref.groups;

  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/base', { groups: groups });
};

var getBase = function getBase() {
  return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/base');
};

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raven_js_plugins_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_raven_js_plugins_vue__);











__WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.config('https://6ea32d67d0da48f2940758e63402ce62@sentry.io/239626').addPlugin(__WEBPACK_IMPORTED_MODULE_8_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_5__auth__["a" /* checkAuth */]() && to.name !== 'auth') {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('auth/logout');
    next({
      name: 'auth'
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.setUserContext({
      email: __WEBPACK_IMPORTED_MODULE_5__auth__["b" /* tokenPayload */]('email')
    });
    next();
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
}).$mount('#app');

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_auth__ = __webpack_require__(69);


var login = function login(_ref, _ref2) {
  var commit = _ref.commit;
  var email = _ref2.email,
      password = _ref2.password;

  return __WEBPACK_IMPORTED_MODULE_0__api_auth__["a" /* login */](email, password).then(function (token) {
    window.localStorage.setItem('jwt', token);
    commit('login', JSON.parse(atob(token.split('.')[0])).user);
  });
};

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authenticated", function() { return authenticated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
var authenticated = function authenticated(state) {
  return state.authenticated;
};

var user = function user(state) {
  return state.user;
};

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(98);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    authenticated: false,
    user: {
      company: {
        name: null,
        id: null
      },
      name: null
    }
  },
  mutations: {
    login: function login(state, _ref) {
      var company = _ref.company,
          name = _ref.name;

      state.user = { company: company, name: name };
      state.authenticated = true;
    },
    logout: function logout(state) {
      state.user = { company: null, name: null };
      state.authenticated = false;
    }
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__
});

/***/ })

},[96]);


// WEBPACK FOOTER //
// static/js/app.671750a22a5ba3b0f798.js